// const API_VERSION = "1.0.0";

export const SITE_NAME = "RR Group";
export const CURRENCY = "৳";

// const ROOT_URL = "http://46.28.44.148:8000";
// const ROOT_URL = "http://62.72.44.92:8011";
const ROOT_URL = "https://api.rrgroup.com.bd";
// const ROOT_URL = "http://46.28.44.148:8000";
// const ROOT_URL = "http://localhost:8011";
// const ROOT_URL = "http://192.168.1.120:8000";

export const IMAGE_URL = `${ROOT_URL}/files`;
export const FILE_URL = `${ROOT_URL}/files`;
// const ROOT_URL = "http://192.168.0.111:8000";
// export const IMAGE_URL = "http://192.168.0.111:8000";
// export const FILE_URL = "http://192.168.0.111:8000";

const API_URL = `${ROOT_URL}`;

// auth
export const LOGIN_URL = `${API_URL}/login`;
export const REFRESH_TOKEN = `${API_URL}/login/refresh-token`;

// user
export const GET_ALL_USER = `${API_URL}/users`;
export const GET_USER_PROFILE = `${API_URL}/profile`;
export const GET_USER_BY_ID = `${API_URL}/users/id`;
export const CREATE_USER_URL = `${API_URL}/users/create`;
export const UPDATE_USER_URL = `${API_URL}/users/update`;
export const CHANGE_PASSWORD_URL = `${API_URL}/users/change-user-password`;
export const DELETE_USER_URL = `${API_URL}/users/delete`;
export const UPLOAD_PROFILE_IMAGE = `${API_URL}/upload/profile-image`;
export const UPLOAD_STORE_PROFILE_IMAGE = `${API_URL}/upload/profile-image`;
export const UPLOAD_STORE_LOGO_IMAGE = `${API_URL}/upload/profile-image`;
export const UPLOAD_IMAGE_URL = `${API_URL}/upload-image`;

// customer
export const GET_ALL_CUSTOMERS = `${API_URL}/customers`;
export const GET_CUSTOMER_BY_ID = `${API_URL}/customers/id`;
export const CREATE_CUSTOMER_URL = `${API_URL}/customers/create`;
export const UPDATE_CUSTOMER_URL = `${API_URL}/customers/update`;
export const DELETE_CUSTOMER_URL = `${API_URL}/customers/delete`;

// team members
export const GET_ALL_TEAM_MEMBERS = `${API_URL}/teamMember`;
export const GET_TEAM_MEMBER_BY_ID = `${API_URL}/teamMember/id`;
export const CREATE_TEAM_MEMBER_URL = `${API_URL}/teamMember/create`;
export const UPDATE_TEAM_MEMBER_URL = `${API_URL}/teamMember/update`;
export const DELETE_TEAM_MEMBER_URL = `${API_URL}/teamMember/delete`;
export const UPLOAD_TEAM_MEMBER_IMAGE_URL = `${API_URL}/suite-image`;
// suit
export const GET_ALL_SUITS = `${API_URL}/suite`;
export const GET_SUIT_BY_ID = `${API_URL}/suite/id`;
export const CREATE_SUIT_URL = `${API_URL}/suite/create`;
export const UPDATE_SUIT_URL = `${API_URL}/suite/update`;
export const DELETE_SUIT_URL = `${API_URL}/suite/delete`;
export const UPLOAD_SUIT_IMAGE_URL = `${API_URL}/suite-image`;

// banner
export const GET_ALL_BANNERS = `${API_URL}/banners`;
export const GET_BANNER_BY_ID = `${API_URL}/banners/id`;
export const CREATE_BANNER_URL = `${API_URL}/banners/create`;
export const UPDATE_BANNER_URL = `${API_URL}/banners/update`;
export const DELETE_BANNER_URL = `${API_URL}/banners/delete`;

// philanthropic
export const GET_ALL_PHILANTHROPICS = `${API_URL}/philanthropic`;
export const GET_PHILANTHROPIC_BY_ID = `${API_URL}/philanthropic/id`;
export const CREATE_PHILANTHROPIC_URL = `${API_URL}/philanthropic/create`;
export const UPDATE_PHILANTHROPIC_URL = `${API_URL}/philanthropic/update`;
export const DELETE_PHILANTHROPIC_URL = `${API_URL}/philanthropic/delete`;

// gallery
export const GET_ALL_GALLERIES = `${API_URL}/gallery`;
export const GET_GALLERY_BY_ID = `${API_URL}/gallery/id`;
export const CREATE_GALLERY_URL = `${API_URL}/gallery/create`;
export const UPDATE_GALLERY_URL = `${API_URL}/gallery/update`;
export const DELETE_GALLERY_URL = `${API_URL}/gallery/delete`;

// tributes
export const GET_ALL_TRIBUTES = `${API_URL}/tributes`;
export const GET_TRIBUTE_BY_ID = `${API_URL}/tributes/id`;
export const CREATE_TRIBUTE_URL = `${API_URL}/tributes/create`;
export const UPDATE_TRIBUTE_URL = `${API_URL}/tributes/update`;
export const DELETE_TRIBUTE_URL = `${API_URL}/tributes/delete`;

// activity
export const GET_ALL_ACTIVITIES = `${API_URL}/activities`;
export const GET_ACTIVITY_BY_ID = `${API_URL}/activities/id`;
export const CREATE_ACTIVITY_URL = `${API_URL}/activities/create`;
export const UPDATE_ACTIVITY_URL = `${API_URL}/activities/update`;
export const DELETE_ACTIVITY_URL = `${API_URL}/activities/delete`;

// Complimentary
export const GET_ALL_COMPLIMENTARIES = `${API_URL}/complimentaries`;
export const GET_COMPLIMENTARY_BY_ID = `${API_URL}/complimentaries/id`;
export const CREATE_COMPLIMENTARY_URL = `${API_URL}/complimentaries/create`;
export const UPDATE_COMPLIMENTARY_URL = `${API_URL}/complimentaries/update`;
export const DELETE_COMPLIMENTARY_URL = `${API_URL}/complimentaries/delete`;

// Accommodation
export const GET_ALL_ACCOMMODATION = `${API_URL}/accommodation`;
export const GET_ACCOMMODATION_BY_ID = `${API_URL}/accommodation/id`;
export const CREATE_ACCOMMODATION_URL = `${API_URL}/accommodation/create`;
export const UPDATE_ACCOMMODATION_URL = `${API_URL}/accommodation/update`;
export const DELETE_ACCOMMODATION_URL = `${API_URL}/accommodation/delete`;

// booking
export const GET_ALL_BOOKING = `${API_URL}/booking`;
export const GET_BOOKING_BY_ID = `${API_URL}/booking/id`;
export const UPDATE_BOOKING_URL = `${API_URL}/booking/update`;
export const DELETE_BOOKING_URL = `${API_URL}/booking/delete`;

// stores
export const GET_ALL_STORES = `${API_URL}/stores`;
export const GET_STORE_BY_ID = `${API_URL}/stores/id`;
export const CREATE_STORE_URL = `${API_URL}/stores/create`;
export const UPDATE_STORE_URL = `${API_URL}/stores/update`;
export const DELETE_STORE_URL = `${API_URL}/stores/delete`;

// static page
export const GET_ALL_STATIC_PAGES = `${API_URL}/static-page`;
export const GET_STATIC_PAGE_BY_ID = `${API_URL}/static-page/id`;
export const CREATE_STATIC_PAGE_URL = `${API_URL}/static-page/create`;
export const UPDATE_STATIC_PAGE_URL = `${API_URL}/static-page/update`;
export const DELETE_STATIC_PAGE_URL = `${API_URL}/static-page/delete`;
export const UPLOAD_STATIC_PAGE_IMAGE_URL = `${API_URL}/suite-image`;

// site config
export const GET_ALL_SITE_CONFIGS = `${API_URL}/site-config`;
export const GET_SITE_CONFIG_BY_ID = `${API_URL}/site-config/id`;
export const CREATE_SITE_CONFIG_URL = `${API_URL}/site-config/create`;
export const UPDATE_SITE_CONFIG_URL = `${API_URL}/site-config/update`;
export const DELETE_SITE_CONFIG_URL = `${API_URL}/site-config/delete`;
export const UPLOAD_SITE_CONFIG_LOGO_URL = `${API_URL}/suite-image`;

// promotion
export const GET_ALL_PROMOTIONS = `${API_URL}/promotion`;
export const GET_PROMOTION_BY_ID = `${API_URL}/promotion/id`;
export const CREATE_PROMOTION_URL = `${API_URL}/promotion/create`;
export const UPDATE_PROMOTION_URL = `${API_URL}/promotion/update`;
export const DELETE_PROMOTION_URL = `${API_URL}/promotion/delete`;
export const UPLOAD_PROMOTION_IMAGE_URL = `${API_URL}/suite-image`;

// Blogs
export const GET_ALL_BLOGS = `${API_URL}/blogs`;
export const GET_BLOG_BY_ID = `${API_URL}/blogs/id`;
export const CREATE_BLOG_URL = `${API_URL}/blogs/create`;
export const UPDATE_BLOG_URL = `${API_URL}/blogs/update`;
export const DELETE_BLOG_URL = `${API_URL}/blogs/delete`;
export const UPLOAD_BLOG_IMAGE_URL = `${API_URL}/suite-image`;

// Business
export const GET_ALL_BUSINESSS = `${API_URL}/business`;
export const GET_BUSINESS_BY_ID = `${API_URL}/business/id`;
export const CREATE_BUSINESS_URL = `${API_URL}/business/create`;
export const UPDATE_BUSINESS_URL = `${API_URL}/business/update`;
export const DELETE_BUSINESS_URL = `${API_URL}/business/delete`;

export const GET_ALL_CUSTOMER_FEEDBACK = `${API_URL}/customer-feedback`;

// package
export const GET_ALL_PACKAGES = `${API_URL}/package`;
export const GET_PACKAGE_BY_ID = `${API_URL}/package/id`;
export const CREATE_PACKAGE_URL = `${API_URL}/package/create`;
export const UPDATE_PACKAGE_URL = `${API_URL}/package/update`;
export const DELETE_PACKAGE_URL = `${API_URL}/package/delete`;
export const UPLOAD_PACKAGE_IMAGE_URL = `${API_URL}/suite-image`;

// ourStory

export const GET_ALL_OURSTORY = `${API_URL}/ourStory`;
export const GET_OURSTORY_BY_ID = `${API_URL}/ourStory/id`;
export const CREATE_OURSTORY_URL = `${API_URL}/ourStory/create`;
export const UPDATE_OURSTORY_URL = `${API_URL}/ourStory/update`;
export const DELETE_OURSTORY_URL = `${API_URL}/ourStory/delete`;
// founder

export const GET_ALL_FOUNDER = `${API_URL}/founder`;
export const GET_FOUNDER_BY_ID = `${API_URL}/founder/id`;
export const CREATE_FOUNDER_URL = `${API_URL}/founder/create`;
export const UPDATE_FOUNDER_URL = `${API_URL}/founder/update`;
export const DELETE_FOUNDER_URL = `${API_URL}/founder/delete`;
// groupMilestone

export const GET_ALL_GROUPMILESTONE = `${API_URL}/groupMilestone`;
export const GET_GROUPMILESTONE_BY_ID = `${API_URL}/groupMilestone/id`;
export const CREATE_GROUPMILESTONE_URL = `${API_URL}/groupMilestone/create`;
export const UPDATE_GROUPMILESTONE_URL = `${API_URL}/groupMilestone/update`;
export const DELETE_GROUPMILESTONE_URL = `${API_URL}/groupMilestone/delete`;
// company

export const GET_ALL_COMPANY = `${API_URL}/company`;
export const GET_COMPANY_BY_ID = `${API_URL}/company/id`;
export const CREATE_COMPANY_URL = `${API_URL}/company/create`;
export const UPDATE_COMPANY_URL = `${API_URL}/company/update`;
export const DELETE_COMPANY_URL = `${API_URL}/company/delete`;
// CONSTANT_EXPORTS_AREA

export const ACCESS_TOKEN = "u-pos-access-token";
export const STORE_ID = "u-pos-store-id";
export const PROFILE = "u-pos-profile";

export const ORDER_STATE_COLOR = {
    INITIATED: "",
    SUPPLIER_ACCEPTED: "cyan",
    DELIVERY_MAN_PICKED: "blue",
    COMPLETED: "green",
    CANCELED: "red"
};

export const GENDER_COLOR = {
    MALE: "blue",
    FEMALE: "green",
    OTHERS: "purple"
};
export const COMPANY = {
    name: "URELAA",
    address: "Dhaka Division, Bangladesh"
};

export const BACK_BUTTON_COLOR = "#3390FF";
// end
